module.exports = __webpack_public_path__ + "static/cryptik-banner-two-thumb-eaaee878e45afdbe816de3f699c96cf6.svg";